export const STATUS_CODE = {
  // 返回操作成功
  CODE_SUCCESS: 2000,
  // 返回错误
  CODE_ERROR: 5000,
  // 参数错误
  CODE_ERROR_PARAMS: 5001,
  // URL注册失败
  CODE_ERROR_URL_REG_FAILURE: 5002,
  // 参数错误
  CODE_ERROR_NO_PARAM: 5003,
  // 权限错误
  CODE_ERROR_PERSSION_ERROR: 5004,
  // JWT 验证错误
  CODE_JWT_ERROR: 5100,
  // 登录失败
  CODE_JWT_LOGIN_FAILURE: 5101,
  // JWT Token 无效
  CODE_JWT_TOKEN_INVALID: 5104,
  // 无任何用户
  CODE_JWT_NO_USER: 5103
}



// WEBPACK FOOTER //
// ./src/api/common/codes.js